import React, { useState } from "react";
import { Typography } from '@mui/material';
import './Chat.css';

function Chat() {
    const [mensagem, setMensagem] = useState('');
    const [conversas, setConversas] = useState([
      { de: 'AI', texto: 'Olá! Como posso te ajudar hoje?' },
    ]);
  
    function handleEnviarMensagem() {
      if (mensagem.trim() === '') return;
  
      // Adiciona a mensagem do usuário
      setConversas([...conversas, { de: 'Você', texto: mensagem }]);
      
      // Aqui você poderia fazer uma chamada à sua API (backend) para gerar a resposta da IA.
      // Por enquanto, vamos só simular que a AI respondeu depois de você:
      setTimeout(() => {
        setConversas((prev) => [
          ...prev,
          { de: 'AI', texto: 'Estou aqui para te ajudar!' },
        ]);
      }, 1000);
  
      // Limpa o input
      setMensagem('');
    }
  
    return (
      <div className="app">
        <header className="header">
          <h1>Meu Chat com LLM</h1>
        </header>
  
        <div className="chat-container">
          {conversas.map((msg, index) => (
            <div
              key={index}
              className={`mensagem ${msg.de === 'AI' ? 'ai' : 'voce'}`}
            >
              <strong>{msg.de}:</strong> {msg.texto}
            </div>
          ))}
        </div>
  
        <div className="input-container">
          <input
            type="text"
            placeholder="Digite sua mensagem..."
            value={mensagem}
            onChange={(e) => setMensagem(e.target.value)}
          />
          <button onClick={handleEnviarMensagem}>Enviar</button>
        </div>
      </div>
    );
}

export default Chat;
